import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { facilityStayAction, patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';
const {
  GET_PATIENTS_REQUEST,
  GET_PATIENTS_SUCCESS,
  GET_PATIENTS_FAILURE,
  GET_PATIENTS_LOADER,
  GET_PATIENTS_RESET,
} = facilityStayAction;

function* getPaginatedPatient(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PATIENTS_LOADER });
    const response = yield call(patientService.getPatientRecord, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PATIENTS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENTS_FAILURE, payload: error });
  }
}

function* getPaginatedPatientSaga() {
  yield takeEvery(GET_PATIENTS_REQUEST, getPaginatedPatient);
}

export default getPaginatedPatientSaga;
